import { useState, type ImgHTMLAttributes } from "react";
import type { BundleOfferImages } from "../../../../../logic/helpers/bundleOfferPresentation";
import { localizedValueCandidates } from "../../../../../logic/helpers/localizedText";

interface BundleOfferImageProps extends Omit<
    ImgHTMLAttributes<HTMLImageElement>,
    "src" | "srcSet" | "onError"
> {
    sources: BundleOfferImages;
    locale: string;
}

export function BundleOfferImage({
    sources,
    locale,
    alt,
    ...props
}: BundleOfferImageProps) {
    const [failedSources, setFailedSources] = useState<ReadonlySet<string>>(
        new Set(),
    );
    const source = localizedValueCandidates(sources, locale).find(
        (candidate) => candidate.length > 0 && !failedSources.has(candidate),
    );
    if (!source)
        return alt ? (
            <span className={props.className} style={props.style}>
                {alt}
            </span>
        ) : null;
    return (
        <img
            {...props}
            src={source}
            alt={alt}
            draggable={false}
            onError={() => {
                setFailedSources((previous) => new Set([...previous, source]));
            }}
        />
    );
}
